import axios from 'axios';
import { useHandleErrorResponse } from 'hooks/useHandleErrorResponse';
import { getCurrectPhoneNumber } from 'util/getCurrectPhoneNumber';

const axiosInstance = axios.create({
  baseURL: '/comExec/api/index.php?api_path=',
});

export const getCurrentAptData = async (domain, user_id) => {
  return await axiosInstance({
    url: `/apt/boot?host=${domain}&user_id=${user_id}`,
  })
    .then((res) => res.data)
    .catch((err) => useHandleErrorResponse(err));
};

export const getMenuData = async (apt_id) => {
  return await axiosInstance({
    url: `/site/navigations?apt_id=${apt_id}`,
    method: 'GET',
  })
    .then((res) => res.data)
    .catch((err) => useHandleErrorResponse(err));
};

export const getMyData = async (user_no) => {
  return await axiosInstance({
    url: `/users/${user_no}`,
    method: 'GET',
  })
    .then((res) => res.data)
    .catch((err) => useHandleErrorResponse(err));
};

export const getFavoriteData = async (apt_id) => {
  return await axiosInstance({
    url: `/site/favorites?apt_id=${apt_id}&enabled=true`,
    method: 'get',
  })
    .then((res) => res.data)
    .catch((err) => useHandleErrorResponse(err));
};

export const getContactData = async (apt_id, level) => {
  return await axiosInstance({
    url: `/users?apt_id=${apt_id}&level=${level}&offset=0&limit=100`,
  })
    .then((res) => res.data)
    .catch((err) => useHandleErrorResponse(err));
};

export const modifyMyEmail = async (email, user_no) => {
  return await axiosInstance({
    url: `/users/${user_no}`,
    method: 'PUT',
    data: { email },
  })
    .then((res) => res.data)
    .catch((err) => useHandleErrorResponse(err));
};

export const modifyMyPhone = async (phone, user_no) => {
  return await axiosInstance({
    url: `/users/${user_no}`,
    method: 'PUT',
    data: { phone: getCurrectPhoneNumber(phone) },
  })
    .then((res) => res.data)
    .catch((err) => useHandleErrorResponse(err));
};

export const modifyMyPassword = async (password, user_no) => {
  return await axiosInstance({
    url: `/users/${user_no}`,
    method: 'put',
    data: { password },
  })
    .then((res) => res.data)
    .catch((err) => useHandleErrorResponse(err));
};

export const verifyCurrentPassword = async (password) => {
  return await axiosInstance({
    url: `/users/verify/password`,
    method: 'post',
    data: { password },
  })
    .then((res) => res.data)
    .catch((err) => useHandleErrorResponse(err));
};

export const requestSmsToken = async (apt_id, phone) => {
  phone = getCurrectPhoneNumber(phone);

  return await axiosInstance({
    url: '/sms-verification/issue',
    method: 'POST',
    data: {
      apt_id,
      phone,
    },
  })
    .then((res) => res.data)
    .catch((err) => useHandleErrorResponse(err));
};

export const verifyPhoneNumber = async (apt_id, phoneNumber) => {
  return await axiosInstance({
    url: `/users/exists?apt_id=${apt_id}&phone=${getCurrectPhoneNumber(
      phoneNumber,
    )}`,
  })
    .then((res) => res.data)
    .catch((err) => useHandleErrorResponse(err));
};

export const verifySmsToken = async (phone, verifyToken) => {
  phone = getCurrectPhoneNumber(phone);
  return await axiosInstance({
    url: '/sms-verification/verify',
    method: 'POST',
    data: {
      phone,
      token: verifyToken,
    },
  })
    .then((res) => res)
    .catch((err) => err.response);
};

export const verifyCaptcha = async (token) => {
  return await axios
    .post('http://recaptcha.p14.aptstory.com:8100', { token })
    .then((res) => res.data)
    .catch((err) => useHandleErrorResponse(err));
};
